import DocHead from 'components/DocHead/DocHead'

export default DocHead
